import { useMemo } from "react";
import { getJwtRoleSlug } from "../../../public/utils/jwtRole";
import { getStoredAuthRole } from "../../../public/utils/authSession";
import { getAuthItem } from "../../../public/utils/authStorage";
import { useCallLogRolePermissions } from "../hooks/useCallLogRolePermissions";
import {
  buildCallLogPermissions,
  buildCallLogPermissionsForScreen,
} from "./callLogPermissions";

function resolveRoleSlug() {
  return (
    getJwtRoleSlug(getAuthItem("jwt_token")) ||
    getStoredAuthRole() ||
    ""
  );
}

/** Call log permissions for a screen slug (control or register). */
export function useCallLogRole(screenSlug = null) {
  const sessionRoleSlug = useMemo(() => resolveRoleSlug(), []);

  const {
    permissions,
    roleSlug: apiRoleSlug,
    loading: permLoading,
    error: permissionsError,
  } = useCallLogRolePermissions(Boolean(sessionRoleSlug));

  const roleSlug = apiRoleSlug || sessionRoleSlug;

  const perms = useMemo(() => {
    if (screenSlug) {
      return buildCallLogPermissionsForScreen(permissions, roleSlug, screenSlug);
    }
    return buildCallLogPermissions(permissions);
  }, [permissions, roleSlug, screenSlug]);

  return {
    roleSlug,
    permissionsLoading: permLoading,
    permissionsError,
    isAdmin: perms.isAdmin,
    canView: perms.canView,
    canCreate: perms.canCreate,
    canEdit: perms.canEdit,
    canDelete: perms.canDelete,
    canManageMasters: perms.canManageMasters,
    canDeleteMasters: perms.canDeleteMasters,
    canExport: perms.canExport,
  };
}
